import React from "react";
import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "@/context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isLight ? "Switch to dark theme" : "Switch to light theme"}
      title={isLight ? "Dark theme" : "Light theme"}
      className="inline-flex items-center justify-center h-10 w-10 rounded-sm border border-slate-700 bg-slate-800 text-slate-200 hover:bg-slate-700/60 transition-colors"
      data-testid="theme-toggle"
    >
      {isLight ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
